import { HttpService } from "../HttpService";
import { URL } from "enum";
const URL_API = URL.BASE;

const BeneficioService = {

	async listar() {
		const respuesta = await HttpService(URL_API).get("/portal-colaborador/comunicaciones-cultura/beneficios");
		return respuesta.data;
	},

	async listarHistorico() {
		const respuesta = await HttpService(URL_API).get("/portal-colaborador/comunicaciones-cultura/beneficios/historico");
		return respuesta.data;
	},

	async listarPendientesAprobacion() {
		const respuesta = await HttpService(URL_API).get("/portal-colaborador/comunicaciones-cultura/beneficios/pendientes-aprobacion");
		return respuesta.data;
	},

	async insertar(payload) {
		const respuesta = await HttpService(URL_API).post("/portal-colaborador/comunicaciones-cultura/beneficios", payload);
		return respuesta.data;
	},

	async aprobar(beneficioId) {
		const respuesta = await HttpService(URL_API).put(`/portal-colaborador/comunicaciones-cultura/beneficios/${beneficioId}/aprobar`);
		return respuesta.data;
	},

	async rechazar(beneficioId, payload) {
		const respuesta = await HttpService(URL_API).put(`/portal-colaborador/comunicaciones-cultura/beneficios/${beneficioId}/rechazar`, payload);
		return respuesta.data;
	},

};

export default BeneficioService;
